"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateGiveawayRequestToJSON = exports.CreateGiveawayRequestFromJSONTyped = exports.CreateGiveawayRequestFromJSON = exports.instanceOfCreateGiveawayRequest = void 0;
var runtime_1 = require("../runtime");
var CreateGiveawayRequestStatistics_1 = require("./CreateGiveawayRequestStatistics");
var GiveawayStatus_1 = require("./GiveawayStatus");
/**
 * Check if a given object implements the CreateGiveawayRequest interface.
 */
function instanceOfCreateGiveawayRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "ownerId" in value;
    isInstance = isInstance && "startDate" in value;
    isInstance = isInstance && "endDate" in value;
    isInstance = isInstance && "actionIds" in value;
    isInstance = isInstance && "statistics" in value;
    isInstance = isInstance && "status" in value;
    return isInstance;
}
exports.instanceOfCreateGiveawayRequest = instanceOfCreateGiveawayRequest;
function CreateGiveawayRequestFromJSON(json) {
    return CreateGiveawayRequestFromJSONTyped(json, false);
}
exports.CreateGiveawayRequestFromJSON = CreateGiveawayRequestFromJSON;
function CreateGiveawayRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'ownerId': json['ownerId'],
        'startDate': (new Date(json['startDate'])),
        'endDate': (new Date(json['endDate'])),
        'actionIds': json['actionIds'],
        'statistics': (0, CreateGiveawayRequestStatistics_1.CreateGiveawayRequestStatisticsFromJSON)(json['statistics']),
        'status': (0, GiveawayStatus_1.GiveawayStatusFromJSON)(json['status']),
        'schedulerConfigId': !(0, runtime_1.exists)(json, 'schedulerConfigId') ? undefined : json['schedulerConfigId'],
    };
}
exports.CreateGiveawayRequestFromJSONTyped = CreateGiveawayRequestFromJSONTyped;
function CreateGiveawayRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ownerId': value.ownerId,
        'startDate': (value.startDate.toISOString()),
        'endDate': (value.endDate.toISOString()),
        'actionIds': value.actionIds,
        'statistics': (0, CreateGiveawayRequestStatistics_1.CreateGiveawayRequestStatisticsToJSON)(value.statistics),
        'status': (0, GiveawayStatus_1.GiveawayStatusToJSON)(value.status),
        'schedulerConfigId': value.schedulerConfigId,
    };
}
exports.CreateGiveawayRequestToJSON = CreateGiveawayRequestToJSON;
